"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useHandlerClose = function (setOptions, onClose, defaultOptions) {
    var handlerClose = (0, react_1.useCallback)(function (event, reason) {
        if (onClose)
            onClose(event, reason);
        if (defaultOptions)
            setOptions(defaultOptions);
    }, [setOptions, onClose, defaultOptions]);
    return handlerClose;
};
exports.default = useHandlerClose;
